<div class="dialog-content">
  <form [formGroup]="formGroup">
    <mat-dialog-content mat-dialog-content>
      <div class="dialog-message fxl-column">
        <span>{{ messageLine1 }}</span>
        @if (messageLine2) {
          <span>{{ messageLine2 }} </span>
        }
        @if (subMessageLine1 || subMessageLine2) {
          <div class="sub-message fxl-column">
            @if (subMessageLine1) {
              <span class="primary-fg"> {{ subMessageLine1 }} </span>
            }
            @if (subMessageLine2) {
              <span class="primary-fg"> {{ subMessageLine2 }} </span>
            }
          </div>
        }
        @if (note) {
          <app-note (linkClickedEvent)="linkClickedEventHandler()" [note]="note" class="mt-16"></app-note>
        }
        <ng-content select="[popup-form]"></ng-content>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button #_declineButton (click)="onDeclineClickedHandler()" color="primary" data-testid="decline-button" mat-button>
        {{ declineLabel }}
      </button>
      <button
        #_acceptButton
        (click)="onAcceptClickedHandler()"
        [disabled]="formInvalidFlag"
        color="primary"
        data-testid="validate-button"
        mat-button
      >
        {{ acceptLabel }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
